import { AccountAllowedStatusClient } from "../../../../../../../../Wrap/Api/Account/AccountAllowedStatus";

export class AccountAllowedStatusAction {
    public static getAccountAllowedStatus(hierarchyId: string, callback) {
        const client = new AccountAllowedStatusClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            callback(result);
        });

        promise.onError((err) => {});
    }
}
